<template>
    <div>
        <create @format-created="reloadOverview" />

        <overview ref="overview" />
    </div>
</template>

<script>

import Create from './Create.vue';
import Overview from './Overview.vue';

export default {
    name: 'index',
    components: {
        Create,
        Overview
    },
    methods: {
        reloadOverview() {
            this.$refs.overview.getFormats();
        }
    }
};
</script>